import { reduce, has, append, pipe, forEach, isEmpty } from 'ramda'

// todo: extract to utility script or something
export function fieldCheckReducer(obj, name) {
  const actualName = name || 'model'
  return reduce(
    (a, n) => (!has(n, obj) ? append(`missing field "${n}" in ${actualName}`, a) : a),
    [],
  )
}

export default obj => {
  const expectedFields = [
    'FeedResources',
    'ResourceTypes',
    'Settings',
    'Resource',
    'Resources',
    'userCanConfigureSegments',
  ]
  const reducer = fieldCheckReducer(obj, 'editModel')
  const validationPipe = pipe(
    reducer,
    forEach(m => console.error(m)),
    isEmpty,
  )
  return validationPipe(expectedFields)
}
